import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles((theme) => ({
    chip: {
        marginBottom: '6px'
    },
    closeButton: {
        position: 'absolute',
        right: '2px',
        top: '2px'
    },
    copyIcon: {
        color: theme.palette.grey.semidark,
        height: '15px',
        width: '15px'
    },
    dialogPaper: {
        height: '90%',
        width: '40%',
        maxWidth: '60%',
        minWidth: '600px'
    },
    indicator: {
        width: '100px'
    },
    loaderContainer: {
        alignItems: 'center',
        display: 'flex',
        height: 'calc(100% - 72px)',
        justifyContent: 'center',
        width: '100%'
    },
    login: {
        marginRight: '6px'
    },
    loginContainer: {
        alignItems: 'center',
        display: 'flex'
    },
    moduleContainer: {
        display: 'flex',
        flexDirection: 'column'
    },
    tab: {
        minWidth: '100px'
    },
    text: {
        fontSize: '14px',
        marginTop: '8px'
    },
    adboxTextField: {
        marginRight: '16px',
        marginTop: '16px',
        width: 'calc(40% - 8px)'
    },
    bottomButtonContainer: {
        display: 'flex',
        justifyContent: 'space-between',
        marginBottom: '25px',
        marginLeft: '60px',
        marginRight: '60px',
        width: '100%'
    },
    bottomButtons: {
        alignItems: 'flex-end',
        display: 'flex'
    },
    configurationAdboxContainer: {
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'center',
        width: '100%'
    },
    configurationContainer: {
        alignItems: 'center',
        borderTop: 'solid ' + theme.palette.grey.light + ' 1px',
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        marginTop: '16px',
        width: '80%',
    },
    dialogContent: {
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        overflow: 'auto',
        padding: 0,
        width: '100%'
    },
    dialogTitle: {
        alignItems: 'center',
        display: 'flex',
        justifyContent: 'center',
        paddingBottom: '5px'
    },
    emailChip: {
        marginRight: '8px',
        marginTop: '8px'
    },
    errorMsg: {
        color: theme.palette.red.main,
        fontFamily: 'roboto',
        fontSize: '12px',
        fontStyle: 'italic',
        marginBottom: '0',
        marginTop: '8px'
    },
    formControl: {
        marginTop: '16px',
        width: '80%'
    },
    labelIMAP: {
        borderTop: 'solid ' + theme.palette.grey.light + ' 1px',
        color: theme.palette.red.main,
        marginTop: '16px',
        paddingTop: '8px',
        width: '80%'
    },
    leftIcon: {
        fontSize: 20,
        marginRight: '8px'
    },
    link: {
        width: '80%'
    },
    modulesContainer: {
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'start',
        width: '80%'
    },
    moduleSiteSelect: {
        width: '100%'
    },
    selectSitesContainer: {
        borderTop: 'solid ' + theme.palette.grey.light + ' 1px',
        display: 'flex',
        flexDirection: 'row',
        paddingTop: '16px',
        width: '80%'
    },
    sitesContainer: {
        marginRight: '10px',
        width: '33%'
    },
    stepContainer: {
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        marginTop: '40px',
        width: '100%'
    },
    moduleStepContainer: {
        display: 'flex',
        height: '100%',
        marginTop: '40px',
        width: '100%'
    },
    textField: {
        marginTop: '16px',
        width: '80%'
    },
    warningUpdateSiteLabel: {
        color: theme.palette.red.main,
        fontWeight: '600',
        marginLeft: '8px'
    }
}));
